import { action } from 'satcheljs';

export interface HIDE_FULL_OPTIONActionMessage {
    closeNativeWindowByFullOptionsId: ((fullOptionsId: string) => void) | undefined;
}
export const hideFullOptions: (
    closeNativeWindowByFullOptionsId?: (fullOptionsId: string) => void
) => HIDE_FULL_OPTIONActionMessage = action(
    'HIDE_FULL_OPTION',
    (
        closeNativeWindowByFullOptionsId?: (fullOptionsId: string) => void
    ): HIDE_FULL_OPTIONActionMessage => ({
        closeNativeWindowByFullOptionsId,
    })
);
